import type { StudioDocument } from './studio-api';
export const formats = [
  ['all', 'Все'],
  ['reels', 'Reels'],
  ['photo', 'Фото'],
  ['video', 'Видео'],
  ['circle', 'Кружки'],
];
export const casts = [
  ['all', 'Все'],
  ['one', 'Один'],
  ['two', 'Двое'],
  ['many', 'Несколько'],
  ['kid', 'Дети'],
  ['pet', 'Питомцы'],
];
export interface BrowseState {
  view: 'home' | 'catalog' | 'tools' | 'collection';
  collection?: StudioDocument;
  q: string;
  tab: string;
  /** Вкладка верхней строки страницы-хозяина («Вы в кино»): all · trend · rec · colls · код подборки */
  top: string;
  format: string;
  cast: string;
  sort: string;
  /** Порядок выбран человеком в меню ⇅. Пока нет — серверу его не передаём: у каждого эндпоинта
      свой набор available_sorts, и на чужой он отвечает 409 studio_sort_unavailable. */
  sortPicked?: boolean;
  section: string;
  searchOpen?: boolean;
  heroSlide?: number;
}
/* Порядок по умолчанию — «Популярные», как у прототипа (C и T: `const C={coll:null,fmt:'all',cast:'all',sort:'pop',…}`,
   `const T={sec:'all',q:'',qo:false,sort:'pop'}`). С 'new' лента каталога шла по id вниз (сцены 66, 65, 64…)
   вместо порядка catItems («больше стилей — выше»), и состав первой страницы расходился целиком. */
export const initialBrowse: BrowseState = { view: 'home', q: '', tab: 'all', top: 'all', format: 'all', cast: 'all', sort: 'pop', section: 'all' };

export const browseStateKey = (state: BrowseState) =>
  JSON.stringify([state.view, state.collection?.id, state.q, state.tab, state.top, state.format, state.cast, state.sort, state.section]);
